import { useListItem } from "@floating-ui/react";
import { ComponentType, useContext } from "react";

import { Clickable } from "@design-system/Clickable/Clickable";
import { OptionComponentProps } from "@design-system/Select/Select";

import { SelectContext } from "../../../SelectContext";

type Props = {
  id: string;
  label: string;
  onSelect?: () => void;
  OptionComponent: ComponentType<OptionComponentProps>;
};

export const OptionContainer = ({
  id,
  label,
  onSelect,
  OptionComponent,
}: Props) => {
  const { activeIndex, selectedIndex, getItemProps, handleSelect } =
    useContext(SelectContext);

  const { ref, index } = useListItem({ label });

  const isActive = activeIndex === index;
  const isSelected = selectedIndex === index;

  return (
    <Clickable
      padding={6}
      ref={ref}
      role="option"
      aria-selected={isActive && isSelected}
      tabIndex={isActive ? 0 : -1}
      {...getItemProps({
        onClick: () => {
          onSelect?.();
          return handleSelect(id, index);
        },
      })}
      stretch
    >
      <OptionComponent id={id} label={label} />
    </Clickable>
  );
};
